<template>
  <div class="layout text-primary ma2 ma3-l lh-copy">
    <span class="text-secondary mb3 f6">Вы вошли в систему с аутентификационными данными
      <a class="link text-secondary underline" :href="baseTproURL" target="_blank">
        ТендерПро
      </a>
    </span>
    <div class="card layout">
      <span class="b">{{ user.userName }}</span>
      <span v-if="role">{{ role.name }}</span>
      <span v-if="department">{{ department.name }}</span>
      <a class="link text-primary underline mt4 b" :href="companyLink" target="_blank">
        {{ company.title }}
      </a>
      <span>{{ company.address }}</span>
      <span>{{ company.phone }}</span>
      <a v-if="company.site" class="link text-primary underline" :href="company.site" target="_blank">
        {{ company.site }}
      </a>
      <a class="mt4 link text-secondary underline" :href="cabinetLink" target="_blank">
        Перейти в кабинет ТендерПро
      </a>
    </div>
  </div>
</template>

<script>
import { tproURL } from '@/utils/app.js'

export default {
  computed: {
    user () {
      return this.$store.getters['session/details']
    },
    role () {
      return this.$store.getters['dict/role'](this.user.userTypeId)
    },
    department () {
      return this.$store.getters['companyInfo/department'](this.user.departmentId)
    },
    company () {
      return this.$store.getters['companyInfo/details']
    },
    companyLink () {
      return `${tproURL()}/view_other_company.shtml?companyid=${this.company.id}`
    },
    cabinetLink () {
      return `${tproURL()}/login.shtml`
    },
    baseTproURL () {
      return tproURL()
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-column-gap: .25rem;
  grid-row-gap: .25rem;
}
.company {
  &-layout {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    grid-row-gap: .25rem;
    font-size: .85rem;
  }
  &-label {
    margin-top: 1rem;
    justify-self: start;
    font-weight: bold;
  }
}
@media screen and (min-width: 60em) {
  .company {
    &-layout {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto;
      grid-column-gap: .5rem;
      grid-row-gap: .5rem;
      font-size: .85rem;
    }
    &-label {
      margin-top: 0rem;
      justify-self: end;
      font-weight: bold;
    }
  }
}
</style>
